import * as Yup from "yup";

export const userSpecialValidation = Yup.object().shape({
  percent: Yup.string().required("وارد کردن درصد الزامی است"),
});
